import React, { useState, useRef, useEffect } from 'react';
import styles from './CurrencyDropdown.module.css';

const currencies = [
  { code: 'USD', label: 'United States Dollar', flagUrl: 'https://flagcdn.com/us.svg' },
  { code: 'EUR', label: 'Euro', flagUrl: 'https://flagcdn.com/eu.svg' },
  { code: 'GBP', label: 'British Pound', flagUrl: 'https://flagcdn.com/gb.svg' },
  { code: 'ZAR', label: 'South African Rand', flagUrl: 'https://flagcdn.com/za.svg' },
];

export default function CurrencyDropdown({ value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const selected = currencies.find((c) => c.code === value);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <button
        type="button"
        className={styles.trigger}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <img src={selected.flagUrl} alt={selected.code} className={styles.flag} />
        {selected.code}
        <span className={styles.chevron}>▼</span>
      </button>

      {isOpen && (
        <ul className={styles.dropdown}>
          {currencies.map((currency) => (
            <li
              key={currency.code}
              className={styles.option}
              onClick={() => {
                onChange(currency.code);
                setTimeout(() => setIsOpen(false), 0); // fix dropdown not closing
              }}
            >
              <img src={currency.flagUrl} alt={currency.code} className={styles.flag} />
              {currency.code} — {currency.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
